import { RouteConfig } from 'vue-router';
const Literature = () => import('./views/literature.vue');
const LiteratureFolder = () => import('./views/literature-folder.vue');
const ExtractDetail = () => import('./views/extract-detail.vue');
const Extract = () => import('./views/extract.vue');
const routers: RouteConfig[] = [
    {
        path: 'literature',
        name: 'literature',
        component: Literature
    },
    {
        path: 'literature-folder',
        name: 'literature-folder',
        component: LiteratureFolder
    },
    {
        path: 'extract-detail',
        name: 'extract-detail',
        component: ExtractDetail
    },
    {
        path: 'extract',
        name: 'extract',
        component: Extract
    },
];
export default routers;

